/** Closed Pure LLM progress phases — never render an unknown code. */
export const PURE_LLM_PROGRESS_LABELS = {
    deciding: 'Deciding what to change…',
    'checking-draft': 'Checking the draft…',
    revising: 'Revising the answer…',
    'loading-details': 'Loading more details…',
    'looking-up-members': 'Looking up organization members…',
    'looking-up-related': 'Looking up related people…',
};

const QID_ONLY = /^Q\d+$/i;

/**
 * @param {unknown} queries
 * @returns {string | null}
 */
export function formatSearchQueries(queries) {
    if (!Array.isArray(queries)) {
        return null;
    }
    const cleaned = queries
        .map((query) => String(query || '').replace(/\s+/g, ' ').trim())
        .filter((query) => query && !QID_ONLY.test(query))
        .slice(0, 3)
        .map((query) => (query.length > 48 ? `${query.slice(0, 45)}…` : query));
    return cleaned.length ? cleaned.join(', ') : null;
}

/**
 * @param {string | null | undefined} phase
 * @returns {string | null}
 */
export function labelForProgressPhase(phase) {
    if (!phase) {
        return null;
    }
    return PURE_LLM_PROGRESS_LABELS[phase] || null;
}
